import type { ClientsListParams } from '@/admin/api/clients';
import { clientsApi } from '@/admin/api/clients';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export type { ClientsListParams };

export const clientsQuery = (params?: ClientsListParams) =>
	queryOptions({
		queryKey: ['clients', params ?? {}] as const,
		queryFn: () => clientsApi.list(params),
		placeholderData: keepPreviousData,
		staleTime: 30_000,
	});
